import React from "react"
import cx from "classnames"

import * as s from "./ProductPersonalisationLimited.module.scss"

import { TextArea } from "@components/common/form/TextArea"

interface ProductPersonalisationLimitedProps {
  className?: string
  value: string
  onChange: (value: string) => void
  error?: string
}

export const ProductPersonalisationLimited: React.FC<ProductPersonalisationLimitedProps> = ({
  className,
  value,
  onChange,
  error,
}) => {
  const handleInputChange = (inputValue: string) => {
    const maxLines = 2
    const maxCharsPerLine = 12
    const lines = inputValue.split(/\r?\n/)

    const processedLines = lines.slice(0, maxLines).map(line => {
      return line.substring(0, maxCharsPerLine)
    })

    // Join the processed lines back into a single string and call the external onChange handler
    onChange(processedLines.join("\n"))
  }

  return (
    <div className={`${className || ""} ${s.ProductPersonalisation}`}>
      <TextArea
        placeholder="Your Name / Message"
        value={value}
        onChange={e => handleInputChange(e.target.value)}
        error={error}
        rows={2}
      />
      {error && (
        <span
          className={cx(s.Error, {
            [s.Error___active]: error,
          })}
        >
          {error}
        </span>
      )}
    </div>
  )
}
